import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import { CategoryIconProvider } from './contexts/CategoryIconContext';

const loadGoogleMapsScript = () => {
  const existingScript = document.getElementById('googleMaps');

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_PUBLIC_GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.id = 'googleMaps';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};

loadGoogleMapsScript();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Register main service worker for PWA
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });

    // Register Firebase messaging service worker
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('✅ Firebase Messaging Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('❌ Firebase Messaging Service Worker registration failed:', error);
      });
  });
}

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <CategoryIconProvider>
      <App />
    </CategoryIconProvider>
  </BrowserRouter>
);
